import { LoggingInScreen } from 'components/logging-in-screen';
import { Screen, ScreenContextTriggerIdentityVerification } from 'components/screen';
import verifyIdentityScreenHTML = require('html-loader!html/verify-identity-screen');

export class VerifyIdentityScreen extends Screen {
  public static readonly screenID: string = 'verify-identity';
  public readonly context: ScreenContextTriggerIdentityVerification;

  public async renderImpl(): Promise<void> {
    this.containerEl.innerHTML = verifyIdentityScreenHTML;

    // Pre-populate the disabled login ID field.
    const loginIDInputEl = this.containerEl.querySelector('input[type="text"]') as HTMLInputElement;
    loginIDInputEl.value = this.context.loginID;
  }

  public async submitImpl(): Promise<void> {
    await this.marinSSO.verifyIdentity({
      password: this.getFormValue('password'),
    });
    this.switchScreen(LoggingInScreen.screenID);
  }

  protected getTitle() {
    return 'Verify Identity';
  }
}
